// // import React, { useState, useEffect } from "react";
// // import { Card, Row, Col, Form, Button, Table, Dropdown } from "react-bootstrap";
// // import { gymMembersAPI } from "../../api/gymMembers";
// // import DatePicker from "react-datepicker";
// // import {
// //   FaFilter,
// //   FaDownload,
// //   FaPrint,
// //   FaChartBar,
// //   FaCalendarAlt,
// // } from "react-icons/fa";
// // import {
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   Legend,
// //   ResponsiveContainer,
// // } from "recharts";
// // import "./MemberReport.css";

// // const MemberReport = () => {
// //   const [members, setMembers] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [filters, setFilters] = useState({
// //     startDate: null,
// //     endDate: null,
// //     status: "all",
// //   });
// //   const [chartData, setChartData] = useState([]);

// //   useEffect(() => {
// //     generateReport();
// //   }, [filters]);

// //   const generateReport = async () => {
// //     setLoading(true);
// //     try {
// //       const params = {};
// //       if (filters.startDate)
// //         params.start_date = filters.startDate.toISOString().split("T")[0];
// //       if (filters.endDate)
// //         params.end_date = filters.endDate.toISOString().split("T")[0];
// //       if (filters.status !== "all") params.status = filters.status;

// //       const response = await gymMembersAPI.getMemberReport(params);
// //       setMembers(response.data.results || response.data);

// //       // Prepare chart data
// //       prepareChartData(response.data.results || response.data);
// //     } catch (error) {
// //       console.error("Error generating report:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const prepareChartData = (data) => {
// //     // Group by join date for chart (monthly)
// //     const monthlyData = data.reduce((acc, member) => {
// //       if (member.created_at) {
// //         const date = new Date(member.created_at);
// //         const monthYear = `${date.getFullYear()}-${(date.getMonth() + 1)
// //           .toString()
// //           .padStart(2, "0")}`;

// //         if (!acc[monthYear]) {
// //           acc[monthYear] = 0;
// //         }
// //         acc[monthYear]++;
// //       }
// //       return acc;
// //     }, {});

// //     const chartDataArray = Object.keys(monthlyData)
// //       .map((monthYear) => ({
// //         month: monthYear,
// //         members: monthlyData[monthYear],
// //       }))
// //       .sort((a, b) => a.month.localeCompare(b.month));

// //     setChartData(chartDataArray);
// //   };

// //   const handleFilterChange = (key, value) => {
// //     setFilters({
// //       ...filters,
// //       [key]: value,
// //     });
// //   };

// //   const exportReport = async (format) => {
// //     try {
// //       const response = await gymMembersAPI.exportMembers(format);

// //       // Create download link
// //       const url = window.URL.createObjectURL(new Blob([response.data]));
// //       const link = document.createElement("a");
// //       link.href = url;
// //       link.setAttribute("download", `members-report.${format}`);
// //       document.body.appendChild(link);
// //       link.click();
// //       link.remove();
// //     } catch (error) {
// //       console.error("Error exporting report:", error);
// //     }
// //   };

// //   const calculateStats = () => {
// //     const totalMembers = members.length;
// //     const activeMembers = members.filter((m) => m.is_active).length;

// //     // New members in last 30 days
// //     const thirtyDaysAgo = new Date();
// //     thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
// //     const newThisMonth = members.filter((m) => {
// //       if (!m.created_at) return false;
// //       const joinDate = new Date(m.created_at);
// //       return joinDate >= thirtyDaysAgo;
// //     }).length;

// //     return {
// //       totalMembers,
// //       activeMembers,
// //       newThisMonth,
// //       inactiveMembers: totalMembers - activeMembers,
// //     };
// //   };

// //   const stats = calculateStats();

// //   return (
// //     <div className="member-report-page">
// //       <div className="page-header mb-4">
// //         <h2 className="mb-0 d-flex align-items-center">
// //           <FaChartBar className="me-2" /> Member Reports
// //         </h2>
// //         <p className="text-muted">Generate detailed reports and analytics</p>
// //       </div>

// //       {/* Filter Card */}
// //       <Card className="mb-4">
// //         <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
// //           <span>
// //             <FaFilter className="me-2" /> Filter Options
// //           </span>
// //           <div>
// //             <Dropdown className="d-inline me-2">
// //               <Dropdown.Toggle variant="success" size="sm">
// //                 <FaDownload className="me-1" /> Export
// //               </Dropdown.Toggle>
// //               <Dropdown.Menu>
// //                 <Dropdown.Item onClick={() => exportReport("csv")}>
// //                   Export as CSV
// //                 </Dropdown.Item>
// //                 <Dropdown.Item onClick={() => exportReport("xlsx")}>
// //                   Export as Excel
// //                 </Dropdown.Item>
// //                 <Dropdown.Item onClick={() => window.print()}>
// //                   <FaPrint className="me-1" /> Print
// //                 </Dropdown.Item>
// //               </Dropdown.Menu>
// //             </Dropdown>
// //           </div>
// //         </Card.Header>
// //         <Card.Body>
// //           <Row>
// //             <Col md={4}>
// //               <Form.Group>
// //                 <Form.Label>Start Date</Form.Label>
// //                 <DatePicker
// //                   selected={filters.startDate}
// //                   onChange={(date) => handleFilterChange("startDate", date)}
// //                   className="form-control"
// //                   placeholderText="Select start date"
// //                   isClearable
// //                 />
// //               </Form.Group>
// //             </Col>
// //             <Col md={4}>
// //               <Form.Group>
// //                 <Form.Label>End Date</Form.Label>
// //                 <DatePicker
// //                   selected={filters.endDate}
// //                   onChange={(date) => handleFilterChange("endDate", date)}
// //                   className="form-control"
// //                   placeholderText="Select end date"
// //                   isClearable
// //                 />
// //               </Form.Group>
// //             </Col>
// //             <Col md={4}>
// //               <Form.Group>
// //                 <Form.Label>Status</Form.Label>
// //                 <Form.Select
// //                   value={filters.status}
// //                   onChange={(e) => handleFilterChange("status", e.target.value)}
// //                 >
// //                   <option value="all">All Status</option>
// //                   <option value="active">Active</option>
// //                   <option value="inactive">Inactive</option>
// //                 </Form.Select>
// //               </Form.Group>
// //             </Col>
// //           </Row>
// //           <div className="text-center mt-3">
// //             <Button
// //               variant="primary"
// //               onClick={generateReport}
// //               disabled={loading}
// //             >
// //               {loading ? "Generating..." : "Generate Report"}
// //             </Button>
// //             <Button
// //               variant="outline-secondary"
// //               className="ms-2"
// //               onClick={() => {
// //                 setFilters({
// //                   startDate: null,
// //                   endDate: null,
// //                   status: "all",
// //                 });
// //               }}
// //             >
// //               Clear Filters
// //             </Button>
// //           </div>
// //         </Card.Body>
// //       </Card>

// //       {/* Statistics Cards */}
// //       <Row className="mb-4">
// //         <Col md={3}>
// //           <Card className="stat-card text-white bg-primary">
// //             <Card.Body>
// //               <div className="d-flex justify-content-between align-items-center">
// //                 <div>
// //                   <h6 className="card-title">Total Members</h6>
// //                   <h2 className="mb-0">{stats.totalMembers}</h2>
// //                 </div>
// //                 <FaChartBar size={40} opacity={0.5} />
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //         <Col md={3}>
// //           <Card className="stat-card text-white bg-success">
// //             <Card.Body>
// //               <div className="d-flex justify-content-between align-items-center">
// //                 <div>
// //                   <h6 className="card-title">Active Members</h6>
// //                   <h2 className="mb-0">{stats.activeMembers}</h2>
// //                 </div>
// //                 <FaChartBar size={40} opacity={0.5} />
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //         <Col md={3}>
// //           <Card className="stat-card text-white bg-warning">
// //             <Card.Body>
// //               <div className="d-flex justify-content-between align-items-center">
// //                 <div>
// //                   <h6 className="card-title">New (Last 30 Days)</h6>
// //                   <h2 className="mb-0">{stats.newThisMonth}</h2>
// //                 </div>
// //                 <FaCalendarAlt size={40} opacity={0.5} />
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //         <Col md={3}>
// //           <Card className="stat-card text-white bg-info">
// //             <Card.Body>
// //               <div className="d-flex justify-content-between align-items-center">
// //                 <div>
// //                   <h6 className="card-title">Inactive Members</h6>
// //                   <h2 className="mb-0">{stats.inactiveMembers}</h2>
// //                 </div>
// //                 <FaChartBar size={40} opacity={0.5} />
// //               </div>
// //             </Card.Body>
// //           </Card>
// //         </Col>
// //       </Row>

// //       {/* Chart Section */}
// //       <Card className="mb-4">
// //         <Card.Header>
// //           <h5 className="mb-0">Membership Growth</h5>
// //         </Card.Header>
// //         <Card.Body>
// //           <div style={{ height: "300px" }}>
// //             <ResponsiveContainer width="100%" height="100%">
// //               <BarChart data={chartData}>
// //                 <CartesianGrid strokeDasharray="3 3" />
// //                 <XAxis dataKey="month" />
// //                 <YAxis />
// //                 <Tooltip />
// //                 <Legend />
// //                 <Bar dataKey="members" fill="#8884d8" name="New Members" />
// //               </BarChart>
// //             </ResponsiveContainer>
// //           </div>
// //         </Card.Body>
// //       </Card>

// //       {/* Report Table */}
// //       <Card>
// //         <Card.Header className="d-flex justify-content-between align-items-center">
// //           <h5 className="mb-0">Detailed Report</h5>
// //           <Button
// //             variant="outline-primary"
// //             size="sm"
// //             onClick={() => window.print()}
// //           >
// //             <FaPrint className="me-1" /> Print
// //           </Button>
// //         </Card.Header>
// //         <Card.Body>
// //           <div className="table-responsive">
// //             <Table hover striped>
// //               <thead>
// //                 <tr>
// //                   <th>Member ID</th>
// //                   <th>Name</th>
// //                   <th>Contact</th>
// //                   <th>Email</th>
// //                   <th>Join Date</th>
// //                   <th>Status</th>
// //                   <th>DOB</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {loading ? (
// //                   <tr>
// //                     <td colSpan="7" className="text-center py-4">
// //                       <div
// //                         className="spinner-border text-primary"
// //                         role="status"
// //                       >
// //                         <span className="visually-hidden">Loading...</span>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ) : members.length === 0 ? (
// //                   <tr>
// //                     <td colSpan="7" className="text-center py-4">
// //                       No data available
// //                     </td>
// //                   </tr>
// //                 ) : (
// //                   members.map((member) => (
// //                     <tr key={member.id}>
// //                       <td>{member.member_id}</td>
// //                       <td>
// //                         {member.first_name} {member.last_name}
// //                       </td>
// //                       <td>{member.mobile_number}</td>
// //                       <td>{member.email}</td>
// //                       <td>
// //                         {member.created_at
// //                           ? new Date(member.created_at).toLocaleDateString()
// //                           : "N/A"}
// //                       </td>
// //                       <td>
// //                         <span
// //                           className={`badge ${
// //                             member.is_active ? "bg-success" : "bg-secondary"
// //                           }`}
// //                         >
// //                           {member.is_active ? "Active" : "Inactive"}
// //                         </span>
// //                       </td>
// //                       <td>
// //                         {member.dob
// //                           ? new Date(member.dob).toLocaleDateString()
// //                           : "N/A"}
// //                       </td>
// //                     </tr>
// //                   ))
// //                 )}
// //               </tbody>
// //             </Table>
// //           </div>
// //         </Card.Body>
// //       </Card>
// //     </div>
// //   );
// // };

// // export default MemberReport;
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Card,
//   Row,
//   Col,
//   Form,
//   Button,
//   Table,
//   Dropdown,
//   Badge,
// } from "react-bootstrap";
// import { gymMembersAPI } from "../../api/gymMembers";
// import DatePicker from "react-datepicker";
// import {
//   FaFilter,
//   FaDownload,
//   FaPrint,
//   FaChartBar,
//   FaCalendarAlt,
//   FaFileExcel,
//   FaRupeeSign,
//   FaUserCheck,
//   FaUserTimes,
//   FaHistory,
// } from "react-icons/fa";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
// } from "recharts";
// import * as XLSX from "xlsx";
// import "./MemberReport.css";
// import "react-datepicker/dist/react-datepicker.css";

// const MemberReport = () => {
//   const [members, setMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filters, setFilters] = useState({
//     startDate: null,
//     endDate: null,
//     status: "all",
//     planStatus: "all",
//   });
//   const [chartData, setChartData] = useState([]);
//   const [pieChartData, setPieChartData] = useState([]);
//   const [stats, setStats] = useState({
//     totalMembers: 0,
//     activeMembers: 0,
//     newThisMonth: 0,
//     inactiveMembers: 0,
//     totalRevenue: 0,
//     pendingRevenue: 0,
//   });
//   const tableRef = useRef();

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

//   useEffect(() => {
//     generateReport();
//   }, []);

//   const generateReport = async () => {
//     setLoading(true);
//     try {
//       // In a real scenario, you would call your API endpoint
//       // const response = await gymMembersAPI.getMemberReport({
//       //   start_date: filters.startDate?.toISOString().split('T')[0],
//       //   end_date: filters.endDate?.toISOString().split('T')[0],
//       //   status: filters.status === 'all' ? undefined : filters.status,
//       // });

//       // For now, let's simulate with the provided data
//       const mockData = [
//         {
//           id: 5,
//           member_id: "VS004",
//           first_name: "barathidhasan",
//           last_name: "a",
//           mobile_number: "7094861938",
//           emergency_number: "7094861938",
//           email: "barathi.brandingworld@gmail.com",
//           address: "8.460/5 sumathi , erichy ,chidambaraviduthi",
//           medical_history: "bad good",
//           photo: null,
//           dob: "2007-12-30",
//           created_at: "2026-01-03T12:11:26.823058+05:30",
//           is_active: false,
//           current_plan: null,
//           previous_plan: {
//             id: 5,
//             member: 5,
//             subscription_type: 1,
//             subscription_period: 2,
//             batch: "morning",
//             registration_fee: "500.00",
//             amount: "4000.00",
//             total_amount: "4500.00",
//             paid_amount: "1000.00",
//             pending_amount: "3500.00",
//             fee_status: "Pending",
//             plan_start_date: "2025-10-03",
//             expiry_date: "2025-12-02",
//             is_active: false,
//             created_at: "2026-01-03T12:35:45.934756+05:30",
//           },
//         },
//         {
//           id: 4,
//           member_id: "VS003",
//           first_name: "praveen",
//           last_name: "r",
//           mobile_number: "9874562302",
//           emergency_number: "9874562302",
//           email: "praveen.brandingworld@gmail.com",
//           address: "9.460/5 sumathi , erichy ,chennai",
//           medical_history: "no",
//           photo: null,
//           dob: "2011-12-31",
//           created_at: "2026-01-03T10:46:47.976431+05:30",
//           is_active: true,
//           current_plan: {
//             id: 7,
//             member: 4,
//             subscription_type: 2,
//             subscription_period: 1,
//             batch: "evening",
//             registration_fee: "1000.00",
//             amount: "3000.00",
//             total_amount: "4500.00",
//             paid_amount: "3500.00",
//             pending_amount: "1000.00",
//             fee_status: "Pending",
//             plan_start_date: "2026-01-05",
//             expiry_date: "2026-02-04",
//             is_active: true,
//             created_at: "2026-01-05T11:17:37.472752+05:30",
//           },
//           previous_plan: {
//             id: 6,
//             member: 4,
//             subscription_type: 2,
//             subscription_period: 3,
//             batch: "morning",
//             registration_fee: "1000.00",
//             amount: "3000.00",
//             total_amount: "5000.00",
//             paid_amount: "4000.00",
//             pending_amount: "1000.00",
//             fee_status: "Pending",
//             plan_start_date: "2025-10-03",
//             expiry_date: "2026-01-01",
//             is_active: false,
//             created_at: "2026-01-03T12:42:41.755751+05:30",
//           },
//         },
//         {
//           id: 2,
//           member_id: "VS001",
//           first_name: "Mugil",
//           last_name: "A",
//           mobile_number: "9940794427",
//           emergency_number: "7094861938",
//           email: "mugilesh.brandingworld@gmail.com",
//           address: "Nungambakkam, Chennai",
//           medical_history: "None",
//           photo:
//             "https://bill.vshapefitness.in/api/media/gym_members/photos/img.jpg",
//           dob: "2000-08-30",
//           created_at: "2025-12-18T11:00:00.809634+05:30",
//           is_active: true,
//           current_plan: {
//             id: 11,
//             member: 2,
//             subscription_type: 1,
//             subscription_period: 2,
//             batch: "evening",
//             registration_fee: "1000.00",
//             amount: "500.00",
//             total_amount: "1500.00",
//             paid_amount: "1500.00",
//             pending_amount: "0.00",
//             fee_status: "Paid",
//             plan_start_date: "2026-01-05",
//             expiry_date: "2026-03-06",
//             is_active: true,
//             created_at: "2026-01-05T12:02:54.901409+05:30",
//           },
//           previous_plan: {
//             id: 10,
//             member: 2,
//             subscription_type: 1,
//             subscription_period: 2,
//             batch: "morning",
//             registration_fee: "500.00",
//             amount: "500.00",
//             total_amount: "1000.00",
//             paid_amount: "1000.00",
//             pending_amount: "0.00",
//             fee_status: "Paid",
//             plan_start_date: "2025-08-05",
//             expiry_date: "2025-10-04",
//             is_active: false,
//             created_at: "2026-01-05T12:00:36.649751+05:30",
//           },
//         },
//       ];

//       // Apply filters
//       let filteredData = mockData.filter((member) => {
//         // Filter by status
//         if (filters.status !== "all") {
//           if (filters.status === "active" && !member.is_active) return false;
//           if (filters.status === "inactive" && member.is_active) return false;
//         }

//         // Filter by date range
//         if (filters.startDate || filters.endDate) {
//           const joinDate = new Date(member.created_at);
//           if (filters.startDate && joinDate < filters.startDate) return false;
//           if (filters.endDate && joinDate > filters.endDate) return false;
//         }

//         // Filter by plan status
//         if (filters.planStatus !== "all" && member.current_plan) {
//           if (
//             filters.planStatus === "paid" &&
//             member.current_plan.fee_status !== "Paid"
//           )
//             return false;
//           if (
//             filters.planStatus === "pending" &&
//             member.current_plan.fee_status !== "Pending"
//           )
//             return false;
//         }

//         return true;
//       });

//       setMembers(filteredData);
//       prepareChartData(filteredData);
//       calculateDetailedStats(filteredData);
//     } catch (error) {
//       console.error("Error generating report:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const prepareChartData = (data) => {
//     // Bar chart data - monthly members
//     const monthlyData = data.reduce((acc, member) => {
//       if (member.created_at) {
//         const date = new Date(member.created_at);
//         const monthYear = `${date.getFullYear()}-${(date.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}`;

//         if (!acc[monthYear]) {
//           acc[monthYear] = 0;
//         }
//         acc[monthYear]++;
//       }
//       return acc;
//     }, {});

//     const barChartData = Object.keys(monthlyData)
//       .map((monthYear) => ({
//         month: monthYear,
//         members: monthlyData[monthYear],
//       }))
//       .sort((a, b) => a.month.localeCompare(b.month));

//     setChartData(barChartData);

//     // Pie chart data - membership distribution
//     const planDistribution = data.reduce((acc, member) => {
//       if (member.current_plan) {
//         const period = member.current_plan.subscription_period;
//         const periodText =
//           period === 1 ? "1 Month" : period === 2 ? "2 Months" : "3 Months";

//         if (!acc[periodText]) {
//           acc[periodText] = 0;
//         }
//         acc[periodText]++;
//       }
//       return acc;
//     }, {});

//     const pieData = Object.keys(planDistribution).map((key) => ({
//       name: key,
//       value: planDistribution[key],
//     }));

//     setPieChartData(pieData);
//   };

//   const calculateDetailedStats = (data) => {
//     const totalMembers = data.length;
//     const activeMembers = data.filter((m) => m.is_active).length;

//     // New members in last 30 days
//     const thirtyDaysAgo = new Date();
//     thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
//     const newThisMonth = data.filter((m) => {
//       if (!m.created_at) return false;
//       const joinDate = new Date(m.created_at);
//       return joinDate >= thirtyDaysAgo;
//     }).length;

//     // Calculate revenue
//     let totalRevenue = 0;
//     let pendingRevenue = 0;

//     data.forEach((member) => {
//       if (member.current_plan) {
//         totalRevenue += parseFloat(member.current_plan.total_amount || 0);
//         pendingRevenue += parseFloat(member.current_plan.pending_amount || 0);
//       }
//     });

//     setStats({
//       totalMembers,
//       activeMembers,
//       newThisMonth,
//       inactiveMembers: totalMembers - activeMembers,
//       totalRevenue,
//       pendingRevenue,
//     });
//   };

//   const handleFilterChange = (key, value) => {
//     setFilters({
//       ...filters,
//       [key]: value,
//     });
//   };

//   const exportToExcel = () => {
//     // Prepare data for Excel export
//     const excelData = members.map((member) => ({
//       "Member ID": member.member_id,
//       "Full Name": `${member.first_name} ${member.last_name}`,
//       "Mobile Number": member.mobile_number,
//       Email: member.email,
//       "Date of Birth": member.dob
//         ? new Date(member.dob).toLocaleDateString()
//         : "N/A",
//       "Join Date": member.created_at
//         ? new Date(member.created_at).toLocaleDateString()
//         : "N/A",
//       Status: member.is_active ? "Active" : "Inactive",
//       Address: member.address,
//       "Medical History": member.medical_history,
//       "Current Plan": member.current_plan ? "Yes" : "No",
//       "Plan Start Date": member.current_plan?.plan_start_date || "N/A",
//       "Plan Expiry Date": member.current_plan?.expiry_date || "N/A",
//       "Plan Status": member.current_plan?.fee_status || "N/A",
//       "Total Amount": member.current_plan
//         ? `₹${member.current_plan.total_amount}`
//         : "N/A",
//       "Paid Amount": member.current_plan
//         ? `₹${member.current_plan.paid_amount}`
//         : "N/A",
//       "Pending Amount": member.current_plan
//         ? `₹${member.current_plan.pending_amount}`
//         : "N/A",
//       Batch: member.current_plan?.batch || "N/A",
//       "Subscription Period": member.current_plan
//         ? member.current_plan.subscription_period === 1
//           ? "1 Month"
//           : member.current_plan.subscription_period === 2
//           ? "2 Months"
//           : "3 Months"
//         : "N/A",
//     }));

//     // Add summary row
//     const summaryRow = {
//       "Member ID": "SUMMARY",
//       "Full Name": "",
//       "Mobile Number": "",
//       Email: "",
//       "Date of Birth": "",
//       "Join Date": "",
//       Status: `Total Members: ${stats.totalMembers}`,
//       Address: `Active: ${stats.activeMembers}`,
//       "Medical History": `Inactive: ${stats.inactiveMembers}`,
//       "Current Plan": `New (30 days): ${stats.newThisMonth}`,
//       "Plan Start Date": "",
//       "Plan Expiry Date": "",
//       "Plan Status": "",
//       "Total Amount": `Total Revenue: ₹${stats.totalRevenue}`,
//       "Paid Amount": `Pending Revenue: ₹${stats.pendingRevenue}`,
//       "Pending Amount": "",
//       Batch: "",
//       "Subscription Period": "",
//     };

//     // Create worksheet
//     const ws = XLSX.utils.json_to_sheet([...excelData, {}, summaryRow]);

//     // Create workbook
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Member Report");

//     // Generate Excel file
//     const fileName = `member-report-${
//       new Date().toISOString().split("T")[0]
//     }.xlsx`;
//     XLSX.writeFile(wb, fileName);
//   };

//   const exportToCSV = () => {
//     const csvData = members.map((member) => ({
//       "Member ID": member.member_id,
//       Name: `${member.first_name} ${member.last_name}`,
//       Mobile: member.mobile_number,
//       Email: member.email,
//       "Join Date": member.created_at
//         ? new Date(member.created_at).toLocaleDateString()
//         : "N/A",
//       Status: member.is_active ? "Active" : "Inactive",
//       "Current Plan": member.current_plan ? "Yes" : "No",
//       "Plan Status": member.current_plan?.fee_status || "N/A",
//       "Amount Paid": member.current_plan
//         ? `₹${member.current_plan.paid_amount}`
//         : "N/A",
//       "Amount Pending": member.current_plan
//         ? `₹${member.current_plan.pending_amount}`
//         : "N/A",
//     }));

//     // Convert to CSV string
//     const headers = Object.keys(csvData[0] || {});
//     const csvRows = [
//       headers.join(","),
//       ...csvData.map((row) =>
//         headers.map((header) => `"${row[header]}"`).join(",")
//       ),
//     ];

//     const csvString = csvRows.join("\n");
//     const blob = new Blob([csvString], { type: "text/csv" });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `member-report-${new Date().toISOString().split("T")[0]}.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const getSubscriptionTypeText = (type) => {
//     return type === 1 ? "Regular" : type === 2 ? "Premium" : "N/A";
//   };

//   const getSubscriptionPeriodText = (period) => {
//     return period === 1 ? "1 Month" : period === 2 ? "2 Months" : "3 Months";
//   };

//   const clearFilters = () => {
//     setFilters({
//       startDate: null,
//       endDate: null,
//       status: "all",
//       planStatus: "all",
//     });
//     generateReport();
//   };

//   return (
//     <div className="member-report-page">
//       <div className="page-header mb-4">
//         <h2 className="mb-0 d-flex align-items-center">
//           <FaChartBar className="me-2" /> Member Reports & Analytics
//         </h2>
//         <p className="text-muted">Generate detailed reports and export data</p>
//       </div>

//       {/* Filter Card */}
//       <Card className="mb-4 shadow-sm">
//         <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
//           <span>
//             <FaFilter className="me-2" /> Filter Options
//           </span>
//           <div>
//             <Dropdown className="d-inline me-2">
//               <Dropdown.Toggle variant="success" size="sm">
//                 <FaDownload className="me-1" /> Export Report
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 <Dropdown.Item onClick={exportToExcel}>
//                   <FaFileExcel className="me-2" /> Export as Excel
//                 </Dropdown.Item>
//                 <Dropdown.Item onClick={exportToCSV}>
//                   <FaDownload className="me-2" /> Export as CSV
//                 </Dropdown.Item>
//                 <Dropdown.Item onClick={() => window.print()}>
//                   <FaPrint className="me-2" /> Print Report
//                 </Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label>Start Date</Form.Label>
//                 <DatePicker
//                   selected={filters.startDate}
//                   onChange={(date) => handleFilterChange("startDate", date)}
//                   className="form-control"
//                   placeholderText="Select start date"
//                   isClearable
//                   dateFormat="dd/MM/yyyy"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label>End Date</Form.Label>
//                 <DatePicker
//                   selected={filters.endDate}
//                   onChange={(date) => handleFilterChange("endDate", date)}
//                   className="form-control"
//                   placeholderText="Select end date"
//                   isClearable
//                   dateFormat="dd/MM/yyyy"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label>Member Status</Form.Label>
//                 <Form.Select
//                   value={filters.status}
//                   onChange={(e) => handleFilterChange("status", e.target.value)}
//                 >
//                   <option value="all">All Members</option>
//                   <option value="active">Active Only</option>
//                   <option value="inactive">Inactive Only</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label>Payment Status</Form.Label>
//                 <Form.Select
//                   value={filters.planStatus}
//                   onChange={(e) =>
//                     handleFilterChange("planStatus", e.target.value)
//                   }
//                 >
//                   <option value="all">All Payments</option>
//                   <option value="paid">Paid Only</option>
//                   <option value="pending">Pending Only</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <div className="text-center mt-4">
//             <Button
//               variant="primary"
//               onClick={generateReport}
//               disabled={loading}
//               className="me-2"
//             >
//               {loading ? (
//                 <>
//                   <span
//                     className="spinner-border spinner-border-sm me-2"
//                     role="status"
//                     aria-hidden="true"
//                   ></span>
//                   Generating...
//                 </>
//               ) : (
//                 "Generate Report"
//               )}
//             </Button>
//             <Button variant="outline-secondary" onClick={clearFilters}>
//               Clear Filters
//             </Button>
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Statistics Cards */}
//       <Row className="mb-4">
//         <Col md={2}>
//           <Card className="stat-card text-white bg-primary">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">Total Members</h6>
//                   <h2 className="mb-0">{stats.totalMembers}</h2>
//                 </div>
//                 <FaChartBar size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={2}>
//           <Card className="stat-card text-white bg-success">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">Active Members</h6>
//                   <h2 className="mb-0">{stats.activeMembers}</h2>
//                 </div>
//                 <FaUserCheck size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={2}>
//           <Card className="stat-card text-white bg-warning">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">New (30 Days)</h6>
//                   <h2 className="mb-0">{stats.newThisMonth}</h2>
//                 </div>
//                 <FaCalendarAlt size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={2}>
//           <Card className="stat-card text-white bg-secondary">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">Inactive</h6>
//                   <h2 className="mb-0">{stats.inactiveMembers}</h2>
//                 </div>
//                 <FaUserTimes size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={2}>
//           <Card className="stat-card text-white bg-info">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">Total Revenue</h6>
//                   <h4 className="mb-0">
//                     <FaRupeeSign size={14} /> {stats.totalRevenue}
//                   </h4>
//                 </div>
//                 <FaRupeeSign size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={2}>
//           <Card className="stat-card text-white bg-danger">
//             <Card.Body>
//               <div className="d-flex justify-content-between align-items-center">
//                 <div>
//                   <h6 className="card-title">Pending Revenue</h6>
//                   <h4 className="mb-0">
//                     <FaRupeeSign size={14} /> {stats.pendingRevenue}
//                   </h4>
//                 </div>
//                 <FaHistory size={30} opacity={0.5} />
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Charts Section */}

//       {/* Detailed Report Table */}
//       <Card className="shadow-sm" ref={tableRef}>
//         <Card.Header className="d-flex justify-content-between align-items-center">
//           <h5 className="mb-0">Detailed Member Report</h5>
//           <div>
//             <Button
//               variant="outline-primary"
//               size="sm"
//               onClick={exportToExcel}
//               className="me-2"
//             >
//               <FaFileExcel className="me-1" /> Excel
//             </Button>
//             <Button
//               variant="outline-secondary"
//               size="sm"
//               onClick={() => window.print()}
//             >
//               <FaPrint className="me-1" /> Print
//             </Button>
//           </div>
//         </Card.Header>
//         <Card.Body>
//           <div className="table-responsive">
//             <Table hover striped bordered>
//               <thead className="table-dark">
//                 <tr>
//                   <th>Member ID</th>
//                   <th>Name</th>
//                   <th>Contact</th>
//                   <th>Email</th>
//                   <th>Status</th>
//                   <th>Current Plan</th>
//                   <th>Payment Status</th>
//                   <th>Amount Paid</th>
//                   <th>Amount Due</th>
//                   <th>Plan Start</th>
//                   <th>Plan End</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="11" className="text-center py-5">
//                       <div
//                         className="spinner-border text-primary"
//                         role="status"
//                       >
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <p className="mt-2">Generating report...</p>
//                     </td>
//                   </tr>
//                 ) : members.length === 0 ? (
//                   <tr>
//                     <td colSpan="11" className="text-center py-4 text-muted">
//                       No members found with the selected filters
//                     </td>
//                   </tr>
//                 ) : (
//                   members.map((member) => (
//                     <tr key={member.id}>
//                       <td>
//                         <Badge bg="primary">{member.member_id}</Badge>
//                       </td>
//                       <td>
//                         <strong>
//                           {member.first_name} {member.last_name}
//                         </strong>
//                         <div className="small text-muted">
//                           DOB:{" "}
//                           {member.dob
//                             ? new Date(member.dob).toLocaleDateString()
//                             : "N/A"}
//                         </div>
//                       </td>
//                       <td>
//                         {member.mobile_number}
//                         <div className="small text-muted">
//                           Emergency: {member.emergency_number}
//                         </div>
//                       </td>
//                       <td>
//                         <a
//                           href={`mailto:${member.email}`}
//                           className="text-decoration-none"
//                         >
//                           {member.email}
//                         </a>
//                       </td>
//                       <td>
//                         <Badge bg={member.is_active ? "success" : "secondary"}>
//                           {member.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         {member.current_plan ? (
//                           <div>
//                             <Badge bg="info" className="me-1">
//                               {getSubscriptionTypeText(
//                                 member.current_plan.subscription_type
//                               )}
//                             </Badge>
//                             <Badge bg="warning">
//                               {getSubscriptionPeriodText(
//                                 member.current_plan.subscription_period
//                               )}
//                             </Badge>
//                             <div className="small">
//                               Batch: {member.current_plan.batch}
//                             </div>
//                           </div>
//                         ) : (
//                           <Badge bg="secondary">No Plan</Badge>
//                         )}
//                       </td>
//                       <td>
//                         {member.current_plan ? (
//                           <Badge
//                             bg={
//                               member.current_plan.fee_status === "Paid"
//                                 ? "success"
//                                 : "danger"
//                             }
//                           >
//                             {member.current_plan.fee_status}
//                           </Badge>
//                         ) : (
//                           "N/A"
//                         )}
//                       </td>
//                       <td className="text-success">
//                         <strong>
//                           {member.current_plan
//                             ? `₹${member.current_plan.paid_amount}`
//                             : "N/A"}
//                         </strong>
//                       </td>
//                       <td className="text-danger">
//                         <strong>
//                           {member.current_plan
//                             ? `₹${member.current_plan.pending_amount}`
//                             : "N/A"}
//                         </strong>
//                       </td>
//                       <td>
//                         {member.current_plan?.plan_start_date
//                           ? new Date(
//                               member.current_plan.plan_start_date
//                             ).toLocaleDateString()
//                           : "N/A"}
//                       </td>
//                       <td>
//                         {member.current_plan?.expiry_date
//                           ? new Date(
//                               member.current_plan.expiry_date
//                             ).toLocaleDateString()
//                           : "N/A"}
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           {/* Summary Section */}
//           {members.length > 0 && (
//             <div className="mt-4 p-3 bg-light rounded">
//               <h6>Report Summary</h6>
//               <Row>
//                 <Col md={3} className="border-end">
//                   <div className="text-center">
//                     <div className="h4 text-primary">{stats.totalMembers}</div>
//                     <div className="text-muted">Total Members</div>
//                   </div>
//                 </Col>
//                 <Col md={3} className="border-end">
//                   <div className="text-center">
//                     <div className="h4 text-success">{stats.activeMembers}</div>
//                     <div className="text-muted">Active Members</div>
//                   </div>
//                 </Col>
//                 <Col md={3} className="border-end">
//                   <div className="text-center">
//                     <div className="h4 text-info">₹{stats.totalRevenue}</div>
//                     <div className="text-muted">Total Revenue</div>
//                   </div>
//                 </Col>
//                 <Col md={3}>
//                   <div className="text-center">
//                     <div className="h4 text-danger">
//                       ₹{stats.pendingRevenue}
//                     </div>
//                     <div className="text-muted">Pending Revenue</div>
//                   </div>
//                 </Col>
//               </Row>
//               <div className="mt-3 text-muted small">
//                 Report generated on: {new Date().toLocaleString()}
//               </div>
//             </div>
//           )}
//         </Card.Body>
//       </Card>

//        <Row className="mb-4">
//         <Col md={8}>
//           <Card className="h-100 shadow-sm">
//             <Card.Header>
//               <h5 className="mb-0">Membership Growth Trend</h5>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: "300px" }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <BarChart data={chartData}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <Tooltip />
//                     <Legend />
//                     <Bar
//                       dataKey="members"
//                       fill="#8884d8"
//                       name="New Members"
//                       radius={[4, 4, 0, 0]}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={4}>
//           <Card className="h-100 shadow-sm">
//             <Card.Header>
//               <h5 className="mb-0">Subscription Period Distribution</h5>
//             </Card.Header>
//             <Card.Body>
//               <div style={{ height: "300px" }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                   <PieChart>
//                     <Pie
//                       data={pieChartData}
//                       cx="50%"
//                       cy="50%"
//                       labelLine={false}
//                       label={({ name, percent }) =>
//                         `${name}: ${(percent * 100).toFixed(0)}%`
//                       }
//                       outerRadius={80}
//                       fill="#8884d8"
//                       dataKey="value"
//                     >
//                       {pieChartData.map((entry, index) => (
//                         <Cell
//                           key={`cell-${index}`}
//                           fill={COLORS[index % COLORS.length]}
//                         />
//                       ))}
//                     </Pie>
//                     <Tooltip />
//                     <Legend />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default MemberReport;

import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Dropdown,
  Badge,
  Alert,
} from "react-bootstrap";
import { gymMembersAPI } from "../../api/gymMembers";
import { subscriptionAPI } from "../../api/subscription"; // Import subscription API
import DatePicker from "react-datepicker";
import {
  FaFilter,
  FaDownload,
  FaPrint,
  FaChartBar,
  FaCalendarAlt,
  FaFileExcel,
  FaRupeeSign,
  FaUserCheck,
  FaUserTimes,
  FaHistory,
  FaExclamationTriangle,
} from "react-icons/fa";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import * as XLSX from "xlsx";
import "./MemberReport.css";
import "react-datepicker/dist/react-datepicker.css";

const MemberReport = () => {
  const [members, setMembers] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [subscriptionPeriods, setSubscriptionPeriods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSubscriptionData, setLoadingSubscriptionData] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    status: "all",
    planStatus: "all",
    subscriptionType: "all",
    subscriptionPeriod: "all",
    batch: "all",
  });
  const [chartData, setChartData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [stats, setStats] = useState({
    totalMembers: 0,
    activeMembers: 0,
    newThisMonth: 0,
    inactiveMembers: 0,
    totalRevenue: 0,
    pendingRevenue: 0,
  });
  const [batches, setBatches] = useState(["morning", "evening"]);
  const tableRef = useRef();

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

  useEffect(() => {
    fetchSubscriptionData();
    generateReport();
  }, []);

  const fetchSubscriptionData = async () => {
    setLoadingSubscriptionData(true);
    setError(null);
    try {
      // Fetch subscription types using the API
      const typesResponse = await subscriptionAPI.getSubscriptionTypes();
      setSubscriptionTypes(typesResponse.data);

      // Fetch subscription periods using the API
      const periodsResponse = await subscriptionAPI.getSubscriptionPeriods();
      setSubscriptionPeriods(periodsResponse.data);
    } catch (error) {
      console.error("Error fetching subscription data:", error);
      setError(
        "Failed to load subscription types and periods. Some filters may not work properly.",
      );

      // Fallback data in case API fails
      setSubscriptionTypes([
        { id: 1, name: "Gym" },
        { id: 2, name: "Cross fit" },
        { id: 3, name: "Cross fit + Gym" },
        { id: 4, name: "Personal Training" },
        { id: 5, name: "Test" },
      ]);

      setSubscriptionPeriods([
        { id: 1, months: 1 },
        { id: 2, months: 2 },
        { id: 3, months: 3 },
        { id: 4, months: 4 },
        { id: 5, months: 5 },
        { id: 6, months: 6 },
      ]);
    } finally {
      setLoadingSubscriptionData(false);
    }
  };

  const generateReport = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await gymMembersAPI.getMembers();
      console.log("API Response:", response); // Debug log

      // Check different possible response structures
      let membersData = [];

      if (response.data && response.data.data) {
        // Structure: { data: { data: [...] } }
        membersData = response.data.data;
      } else if (response.data && Array.isArray(response.data)) {
        // Structure: { data: [...] }
        membersData = response.data;
      } else if (response.data && response.data.results) {
        // Structure: { data: { results: [...] } }
        membersData = response.data.results;
      } else if (response.data) {
        // Structure: { data: { ... } } - try to extract data
        membersData = response.data;
      } else {
        membersData = [];
      }

      console.log("Extracted members data:", membersData); // Debug log

      // Make sure it's an array
      if (!Array.isArray(membersData)) {
        membersData = [];
      }

      // Apply filters
      let filteredData = membersData.filter((member) => {
        // Filter by status
        if (filters.status !== "all") {
          if (filters.status === "active" && !member.is_active) return false;
          if (filters.status === "inactive" && member.is_active) return false;
        }

        // Filter by join date range
        if (filters.startDate || filters.endDate) {
          if (!member.created_at) return false;
          const joinDate = new Date(member.created_at);
          if (filters.startDate && joinDate < filters.startDate) return false;
          if (filters.endDate && joinDate > filters.endDate) return false;
        }

        // Get current plan or previous plan for filtering
        const plan = member.current_plan || member.previous_plan;

        // Filter by plan status (if member has any plan)
        if (filters.planStatus !== "all") {
          if (!plan) return false; // No plan at all
          if (filters.planStatus === "paid" && plan.fee_status !== "Paid")
            return false;
          if (filters.planStatus === "pending" && plan.fee_status !== "Pending")
            return false;
        }

        // Filter by subscription type
        if (filters.subscriptionType !== "all") {
          if (!plan) return false; // No plan at all
          if (plan.subscription_type !== parseInt(filters.subscriptionType))
            return false;
        }

        // Filter by subscription period
        if (filters.subscriptionPeriod !== "all") {
          if (!plan) return false; // No plan at all
          if (plan.subscription_period !== parseInt(filters.subscriptionPeriod))
            return false;
        }

        // Filter by batch
        if (filters.batch !== "all") {
          if (!plan) return false; // No plan at all
          if (plan.batch !== filters.batch) return false;
        }

        return true;
      });

      console.log("Filtered data:", filteredData); // Debug log
      setMembers(filteredData);
      prepareChartData(filteredData);
      calculateDetailedStats(filteredData);
    } catch (error) {
      console.error("Error generating report:", error);
      console.error("Error details:", error.response); // Debug log
      setError(
        "Failed to load member data. Please try again. Error: " + error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const prepareChartData = (data) => {
    // Bar chart data - monthly members
    const monthlyData = data.reduce((acc, member) => {
      if (member.created_at) {
        const date = new Date(member.created_at);
        const monthYear = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}`;

        if (!acc[monthYear]) {
          acc[monthYear] = 0;
        }
        acc[monthYear]++;
      }
      return acc;
    }, {});

    const barChartData = Object.keys(monthlyData)
      .map((monthYear) => ({
        month: monthYear,
        members: monthlyData[monthYear],
      }))
      .sort((a, b) => a.month.localeCompare(b.month));

    setChartData(barChartData);

    // Pie chart data - subscription type distribution
    const subscriptionDistribution = data.reduce((acc, member) => {
      const plan = member.current_plan || member.previous_plan;
      if (plan) {
        const typeId = plan.subscription_type;
        const typeName = getSubscriptionTypeName(typeId);

        if (!acc[typeName]) {
          acc[typeName] = 0;
        }
        acc[typeName]++;
      } else {
        const noPlan = "No Plan";
        if (!acc[noPlan]) {
          acc[noPlan] = 0;
        }
        acc[noPlan]++;
      }
      return acc;
    }, {});

    const pieData = Object.keys(subscriptionDistribution).map((key) => ({
      name: key,
      value: subscriptionDistribution[key],
    }));

    setPieChartData(pieData);
  };

  const calculateDetailedStats = (data) => {
    const totalMembers = data.length;
    const activeMembers = data.filter((m) => m.is_active).length;

    // New members in last 30 days
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const newThisMonth = data.filter((m) => {
      if (!m.created_at) return false;
      const joinDate = new Date(m.created_at);
      return joinDate >= thirtyDaysAgo;
    }).length;

    // Calculate revenue
    let totalRevenue = 0;
    let pendingRevenue = 0;

    data.forEach((member) => {
      if (member.current_plan) {
        totalRevenue += parseFloat(member.current_plan.total_amount || 0);
        pendingRevenue += parseFloat(member.current_plan.pending_amount || 0);
      }
    });

    setStats({
      totalMembers,
      activeMembers,
      newThisMonth,
      inactiveMembers: totalMembers - activeMembers,
      totalRevenue,
      pendingRevenue,
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters({
      ...filters,
      [key]: value,
    });
  };

  const exportToExcel = () => {
    if (members.length === 0) {
      alert("No data to export. Please generate a report first.");
      return;
    }

    // Prepare data for Excel export
    const excelData = members.map((member) => {
      const plan = member.current_plan || member.previous_plan;
      const planSource = member.current_plan ? "Current" : "Previous";

      return {
        "Member ID": member.member_id,
        "Full Name": `${member.first_name} ${member.last_name}`,
        "Mobile Number": member.mobile_number,
        Email: member.email,
        "Date of Birth": member.dob
          ? new Date(member.dob).toLocaleDateString()
          : "N/A",
        "Join Date": member.created_at
          ? new Date(member.created_at).toLocaleDateString()
          : "N/A",
        Status: member.is_active ? "Active" : "Inactive",
        Address: member.address,
        "Medical History": member.medical_history,
        "Plan Source": plan ? planSource : "No Plan",
        "Subscription Type": plan
          ? getSubscriptionTypeName(plan.subscription_type)
          : "N/A",
        "Subscription Period": plan
          ? `${plan.subscription_period} Month(s)`
          : "N/A",
        Batch: plan ? plan.batch : "N/A",
        "Plan Start Date": plan?.plan_start_date || "N/A",
        "Plan Expiry Date": plan?.expiry_date || "N/A",
        "Plan Status": plan?.fee_status || "N/A",
        "Registration Fee": plan ? `₹${plan.registration_fee}` : "N/A",
        "Plan Amount": plan ? `₹${plan.amount}` : "N/A",
        "Total Amount": plan ? `₹${plan.total_amount}` : "N/A",
        "Paid Amount": plan ? `₹${plan.paid_amount}` : "N/A",
        "Pending Amount": plan ? `₹${plan.pending_amount}` : "N/A",
        "Plan Active": plan ? (plan.is_active ? "Yes" : "No") : "N/A",
      };
    });

    // Add summary row
    const summaryRow = {
      "Member ID": "SUMMARY",
      "Full Name": "",
      "Mobile Number": "",
      Email: "",
      "Date of Birth": "",
      "Join Date": "",
      Status: `Total Members: ${stats.totalMembers}`,
      Address: `Active: ${stats.activeMembers}`,
      "Medical History": `Inactive: ${stats.inactiveMembers}`,
      "Plan Source": `New (30 days): ${stats.newThisMonth}`,
      "Subscription Type": "",
      "Subscription Period": "",
      Batch: "",
      "Plan Start Date": "",
      "Plan Expiry Date": "",
      "Plan Status": "",
      "Registration Fee": "",
      "Plan Amount": "",
      "Total Amount": `Total Revenue: ₹${stats.totalRevenue}`,
      "Paid Amount": `Pending Revenue: ₹${stats.pendingRevenue}`,
      "Pending Amount": "",
      "Plan Active": "",
    };

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet([...excelData, {}, summaryRow]);

    // Set column widths
    const wscols = [
      { wch: 10 }, // Member ID
      { wch: 20 }, // Full Name
      { wch: 15 }, // Mobile Number
      { wch: 25 }, // Email
      { wch: 12 }, // Date of Birth
      { wch: 12 }, // Join Date
      { wch: 10 }, // Status
      { wch: 30 }, // Address
      { wch: 15 }, // Medical History
      { wch: 12 }, // Plan Source
      { wch: 20 }, // Subscription Type
      { wch: 18 }, // Subscription Period
      { wch: 10 }, // Batch
      { wch: 12 }, // Plan Start Date
      { wch: 12 }, // Plan Expiry Date
      { wch: 12 }, // Plan Status
      { wch: 15 }, // Registration Fee
      { wch: 12 }, // Plan Amount
      { wch: 12 }, // Total Amount
      { wch: 12 }, // Paid Amount
      { wch: 15 }, // Pending Amount
      { wch: 10 }, // Plan Active
    ];
    ws["!cols"] = wscols;

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Member Report");

    // Generate Excel file
    const fileName = `member-report-${
      new Date().toISOString().split("T")[0]
    }.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const exportToCSV = () => {
    if (members.length === 0) {
      alert("No data to export. Please generate a report first.");
      return;
    }

    const csvData = members.map((member) => {
      const plan = member.current_plan || member.previous_plan;
      const planSource = member.current_plan ? "Current" : "Previous";

      return {
        "Member ID": member.member_id,
        Name: `${member.first_name} ${member.last_name}`,
        Mobile: member.mobile_number,
        Email: member.email,
        "Join Date": member.created_at
          ? new Date(member.created_at).toLocaleDateString()
          : "N/A",
        Status: member.is_active ? "Active" : "Inactive",
        "Plan Source": plan ? planSource : "No Plan",
        "Subscription Type": plan
          ? getSubscriptionTypeName(plan.subscription_type)
          : "N/A",
        Batch: plan ? plan.batch : "N/A",
        "Plan Status": plan?.fee_status || "N/A",
        "Amount Paid": plan ? `₹${plan.paid_amount}` : "N/A",
        "Amount Pending": plan ? `₹${plan.pending_amount}` : "N/A",
        "Plan Start": plan?.plan_start_date || "N/A",
        "Plan End": plan?.expiry_date || "N/A",
      };
    });

    // Convert to CSV string
    const headers = Object.keys(csvData[0] || {});
    const csvRows = [
      headers.join(","),
      ...csvData.map((row) =>
        headers.map((header) => `"${row[header]}"`).join(","),
      ),
    ];

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `member-report-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const getSubscriptionTypeName = (typeId) => {
    const type = subscriptionTypes.find((t) => t.id === typeId);
    return type ? type.name : `Type ${typeId}`;
  };

  const getBatchDisplay = (member) => {
    const plan = member.current_plan || member.previous_plan;
    if (!plan) return { batch: "No Plan", source: "" };

    const source = member.current_plan ? "Current Plan" : "Previous Plan";
    return { batch: plan.batch, source };
  };

  const clearFilters = () => {
    setFilters({
      startDate: null,
      endDate: null,
      status: "all",
      planStatus: "all",
      subscriptionType: "all",
      subscriptionPeriod: "all",
      batch: "all",
    });
  };

  const applyFilters = () => {
    generateReport();
  };

  return (
    <div className="member-report-page">
      <div className="page-header mb-4">
        <h2 className="mb-0 d-flex align-items-center">
          <FaChartBar className="me-2" /> Member Reports & Analytics
        </h2>
        <p className="text-muted">Generate detailed reports and export data</p>
      </div>

      {/* Error Alert */}
      {error && (
        <Alert variant="warning" className="mb-3 d-flex align-items-center">
          <FaExclamationTriangle className="me-2" />
          <div>
            <strong>Warning:</strong> {error}
          </div>
        </Alert>
      )}

      {/* Filter Card */}
      <Card className="mb-4 shadow-sm">
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
          <span>
            <FaFilter className="me-2" /> Filter Options
          </span>
          <div>
            <Dropdown className="d-inline me-2">
              <Dropdown.Toggle variant="success" size="sm">
                <FaDownload className="me-1" /> Export Report
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={exportToExcel}>
                  <FaFileExcel className="me-2" /> Export as Excel
                </Dropdown.Item>
                <Dropdown.Item onClick={exportToCSV}>
                  <FaDownload className="me-2" /> Export as CSV
                </Dropdown.Item>
                <Dropdown.Item onClick={() => window.print()}>
                  <FaPrint className="me-2" /> Print Report
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Start Date</Form.Label>
                <DatePicker
                  selected={filters.startDate}
                  onChange={(date) => handleFilterChange("startDate", date)}
                  className="form-control"
                  placeholderText="Select start date"
                  isClearable
                  dateFormat="dd/MM/yyyy"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>End Date</Form.Label>
                <DatePicker
                  selected={filters.endDate}
                  onChange={(date) => handleFilterChange("endDate", date)}
                  className="form-control"
                  placeholderText="Select end date"
                  isClearable
                  dateFormat="dd/MM/yyyy"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Member Status</Form.Label>
                <Form.Select
                  value={filters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <option value="all">All Members</option>
                  <option value="active">Active Only</option>
                  <option value="inactive">Inactive Only</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Payment Status</Form.Label>
                <Form.Select
                  value={filters.planStatus}
                  onChange={(e) =>
                    handleFilterChange("planStatus", e.target.value)
                  }
                >
                  <option value="all">All Payments</option>
                  <option value="paid">Paid Only</option>
                  <option value="pending">Pending Only</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Subscription Type</Form.Label>
                <Form.Select
                  value={filters.subscriptionType}
                  onChange={(e) =>
                    handleFilterChange("subscriptionType", e.target.value)
                  }
                  disabled={loadingSubscriptionData}
                >
                  <option value="all">All Types</option>
                  {subscriptionTypes.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </Form.Select>
                {loadingSubscriptionData && (
                  <div className="small text-muted mt-1">Loading types...</div>
                )}
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Subscription Period</Form.Label>
                <Form.Select
                  value={filters.subscriptionPeriod}
                  onChange={(e) =>
                    handleFilterChange("subscriptionPeriod", e.target.value)
                  }
                  disabled={loadingSubscriptionData}
                >
                  <option value="all">All Periods</option>
                  {subscriptionPeriods.map((period) => (
                    <option key={period.id} value={period.id}>
                      {period.months} Month(s)
                    </option>
                  ))}
                </Form.Select>
                {loadingSubscriptionData && (
                  <div className="small text-muted mt-1">
                    Loading periods...
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={2}>
              <Form.Group>
                <Form.Label>Batch</Form.Label>
                <Form.Select
                  value={filters.batch}
                  onChange={(e) => handleFilterChange("batch", e.target.value)}
                >
                  <option value="all">All Batches</option>
                  <option value="morning">Morning</option>
                  <option value="evening">Evening</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={10} className="d-flex align-items-end">
              <div className="text-center w-100">
                <Button
                  variant="primary"
                  onClick={applyFilters}
                  disabled={loading || loadingSubscriptionData}
                  className="me-2"
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Generating...
                    </>
                  ) : (
                    "Apply Filters"
                  )}
                </Button>
                <Button variant="outline-secondary" onClick={clearFilters}>
                  Clear Filters
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Statistics Cards */}
      <Row className="mb-4">
        <Col md={2}>
          <Card className="stat-card text-white bg-primary">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">Total Members</h6>
                  <h2 className="mb-0">{stats.totalMembers}</h2>
                </div>
                <FaChartBar size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2}>
          <Card className="stat-card text-white bg-success">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">Active Members</h6>
                  <h2 className="mb-0">{stats.activeMembers}</h2>
                </div>
                <FaUserCheck size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2}>
          <Card className="stat-card text-white bg-warning">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">New (30 Days)</h6>
                  <h2 className="mb-0">{stats.newThisMonth}</h2>
                </div>
                <FaCalendarAlt size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2}>
          <Card className="stat-card text-white bg-secondary">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">Inactive</h6>
                  <h2 className="mb-0">{stats.inactiveMembers}</h2>
                </div>
                <FaUserTimes size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2}>
          <Card className="stat-card text-white bg-info">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">Total Revenue</h6>
                  <h4 className="mb-0">
                    <FaRupeeSign size={14} /> {stats.totalRevenue}
                  </h4>
                </div>
                <FaRupeeSign size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={2}>
          <Card className="stat-card text-white bg-danger">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="card-title">Pending Revenue</h6>
                  <h4 className="mb-0">
                    <FaRupeeSign size={14} /> {stats.pendingRevenue}
                  </h4>
                </div>
                <FaHistory size={30} opacity={0.5} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Charts Section */}
      {members.length > 0 && (
        <Row className="mb-4">
          <Col md={8}>
            <Card className="h-100 shadow-sm">
              <Card.Header>
                <h5 className="mb-0">Membership Growth Trend</h5>
              </Card.Header>
              <Card.Body>
                <div style={{ height: "300px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={chartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="month" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar
                        dataKey="members"
                        fill="#8884d8"
                        name="New Members"
                        radius={[4, 4, 0, 0]}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <Card.Header>
                <h5 className="mb-0">Subscription Type Distribution</h5>
              </Card.Header>
              <Card.Body>
                <div style={{ height: "300px" }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={pieChartData}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, percent }) =>
                          `${name}: ${(percent * 100).toFixed(0)}%`
                        }
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {pieChartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Detailed Report Table */}
      <Card className="shadow-sm" ref={tableRef}>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Detailed Member Report</h5>
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={exportToExcel}
              className="me-2"
              disabled={members.length === 0}
            >
              <FaFileExcel className="me-1" /> Excel
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => window.print()}
            >
              <FaPrint className="me-1" /> Print
            </Button>
          </div>
        </Card.Header>
        <Card.Body>
          <div className="table-responsive">
            <Table hover striped bordered>
              <thead className="table-dark">
                <tr>
                  <th>Member ID</th>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Plan Type</th>
                  <th>Batch (Source)</th>
                  <th>Subscription Period</th>
                  <th>Payment Status</th>
                  <th>Amount Paid</th>
                  <th>Amount Due</th>
                  <th>Plan Start</th>
                  <th>Plan End</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="13" className="text-center py-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Generating report...</p>
                    </td>
                  </tr>
                ) : members.length === 0 ? (
                  <tr>
                    <td colSpan="13" className="text-center py-4 text-muted">
                      No members found with the selected filters. Click "Apply
                      Filters" to generate report.
                    </td>
                  </tr>
                ) : (
                  members.map((member) => {
                    const plan = member.current_plan || member.previous_plan;
                    const batchInfo = getBatchDisplay(member);
                    const planSource = member.current_plan
                      ? "Current"
                      : "Previous";

                    return (
                      <tr key={member.id}>
                        <td>
                          <Badge bg="primary">{member.member_id}</Badge>
                        </td>
                        <td>
                          <strong>
                            {member.first_name} {member.last_name}
                          </strong>
                          <div className="small text-muted">
                            DOB:{" "}
                            {member.dob
                              ? new Date(member.dob).toLocaleDateString()
                              : "N/A"}
                          </div>
                        </td>
                        <td>
                          {member.mobile_number}
                          <div className="small text-muted">
                            Emergency: {member.emergency_number}
                          </div>
                        </td>
                        <td>
                          <a
                            href={`mailto:${member.email}`}
                            className="text-decoration-none"
                          >
                            {member.email}
                          </a>
                        </td>
                        <td>
                          <Badge
                            bg={member.is_active ? "success" : "secondary"}
                          >
                            {member.is_active ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td>
                          {plan ? (
                            <Badge bg="info" className="me-1">
                              {getSubscriptionTypeName(plan.subscription_type)}
                            </Badge>
                          ) : (
                            <Badge bg="secondary">No Plan</Badge>
                          )}
                          <div className="small text-muted">
                            {plan && (
                              <Badge bg="light" text="dark" className="ms-1">
                                {planSource}
                              </Badge>
                            )}
                          </div>
                        </td>
                        <td>
                          <div>
                            {batchInfo.batch !== "No Plan" ? (
                              <>
                                <Badge bg="warning">{batchInfo.batch}</Badge>
                                <div className="small text-muted">
                                  {batchInfo.source}
                                </div>
                              </>
                            ) : (
                              "N/A"
                            )}
                          </div>
                        </td>
                        <td>
                          {plan ? (
                            <Badge bg="secondary">
                              {plan.subscription_period} Month(s)
                            </Badge>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>
                          {plan ? (
                            <Badge
                              bg={
                                plan.fee_status === "Paid"
                                  ? "success"
                                  : "danger"
                              }
                            >
                              {plan.fee_status}
                            </Badge>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td className="text-success">
                          <strong>
                            {plan ? `₹${plan.paid_amount}` : "N/A"}
                          </strong>
                        </td>
                        <td className="text-danger">
                          <strong>
                            {plan ? `₹${plan.pending_amount}` : "N/A"}
                          </strong>
                        </td>
                        <td>
                          {plan?.plan_start_date
                            ? new Date(
                                plan.plan_start_date,
                              ).toLocaleDateString()
                            : "N/A"}
                        </td>
                        <td>
                          {plan?.expiry_date
                            ? new Date(plan.expiry_date).toLocaleDateString()
                            : "N/A"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>

          {/* Summary Section */}
          {members.length > 0 && (
            <div className="mt-4 p-3 bg-light rounded">
              <h6>Report Summary</h6>
              <Row>
                <Col md={3} className="border-end">
                  <div className="text-center">
                    <div className="h4 text-primary">{stats.totalMembers}</div>
                    <div className="text-muted">Total Members</div>
                  </div>
                </Col>
                <Col md={3} className="border-end">
                  <div className="text-center">
                    <div className="h4 text-success">{stats.activeMembers}</div>
                    <div className="text-muted">Active Members</div>
                  </div>
                </Col>
                <Col md={3} className="border-end">
                  <div className="text-center">
                    <div className="h4 text-info">₹{stats.totalRevenue}</div>
                    <div className="text-muted">Total Revenue</div>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="text-center">
                    <div className="h4 text-danger">
                      ₹{stats.pendingRevenue}
                    </div>
                    <div className="text-muted">Pending Revenue</div>
                  </div>
                </Col>
              </Row>
              <div className="mt-3 text-muted small">
                Report generated on: {new Date().toLocaleString()}
                <br />
                Filters applied:{" "}
                {Object.entries(filters)
                  .filter(([key, value]) => value !== "all" && value !== null)
                  .map(([key, value]) => `${key}: ${value}`)
                  .join(", ") || "None"}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default MemberReport;
